export const prephoneViews = {
  LOGIN: "/login",
  FORGOT_PASS: "/forgot-password",
  FORGOT_SIP: "/forgot-address"
};
